/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import Component from 'inferno-component';
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/shared/loader/ellipsis/ellipsis_styles';
import { createStyles } from 'utils/styles';
const sheet = createStyles(styles, { link:false });


/* ========== ~~~~~~~~~~ LOADER : ELLIPSIS : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const EllipsisLoader = () => {
    return (
        <div className={`loader ${sheet.classes.ellipsis}`}>
            <div/>
            <div/>
            <div/>
            <div/>
        </div>
    );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default EllipsisLoader;
